import { Language } from '@/app/enums';
import { countryConfig } from '@/app/utils/countryConfig';
import { getAmountInRespectiveCurrency } from '@/app/utils/numbers';
import { captureException } from '@sentry/nextjs';

export const formatNumber = (value: number, language = 'cs-CZ') => {
  try {
    return value.toLocaleString(language, {
      maximumFractionDigits: 0,
    });
  } catch (error) {
    console.error(error, value, language);
    captureException(error, { extra: { function: 'formatNumber', value, language } });
    return value.toString();
  }
};

export const formatPrice = (value: number) => {
  try {
    return value.toLocaleString(Language.CZ, {
      style: 'currency',
      currency: countryConfig.currency,
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    });
  } catch (error) {
    captureException(error, {
      extra: { function: 'formatPrice', value },
    });

    console.error('Error in formatPrice:', error);
    return value.toString();
  }
};

export const formatPriceInCents = (amountInCents: number) => {
  try {
    const valueInRespectiveCurrency = getAmountInRespectiveCurrency(amountInCents);
    return formatPrice(valueInRespectiveCurrency);
  } catch (error) {
    captureException(error, { extra: { function: 'formatPriceInCents', amountInCents } });
    console.error('Error in formatPriceInCents:', error);
    return amountInCents.toString();
  }
};
